import React from "react";
import {useOutletContext, useParams} from "react-router-dom";
import productData from "../../data/productData";

const Product = () => {
    const { category, type } = useParams();
    const { openModal } = useOutletContext();

    const categoryData = productData[category];
    const typeData = categoryData?.types?.[type];

    if (!categoryData || !typeData) {
        return <h2 className="text-center h-100 mt-5">Product not found</h2>;
    }

    const renderProducts = ({openModal}) => {
        return (
            <div className="container my-4">
                <h2 className="text-center mb-0">{typeData.name}</h2>

                <div className="row align-items-center">
                    <div className="col-12 col-lg-3">
                        <a
                            href={typeData.image}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="d-block w-100"
                        >
                            <img
                                src={typeData.image}
                                alt={typeData.name}
                                className="img-fluid my-3 me-3"
                                style={{ width: "100%", maxHeight: "210px" }}
                            />
                        </a>
                    </div>
                    <div className="col-12 col-lg-9 text-justify">
                        <h6 className="text-secondary">{typeData.name}</h6>
                        <p className="text-muted">{typeData.description}</p>
                    </div>
                </div>

                <div>
                    <h5 data-aos="zoom-in">Why Choose Us:</h5>
                    <ul className="text-muted">
                        {typeData.whyChooseUs.map((whyChooseUs, index) => (
                            <li key={index} data-aos="zoom-in">{whyChooseUs}</li>
                        ))}
                    </ul>
                </div>

                {typeData.specifications && typeData.specifications.length > 0 && (
                    <div>
                        <h5 data-aos="zoom-in">Technical Specification:</h5>
                        <table className="table table-bordered table-striped w-100" data-aos="zoom-in">
                            <thead className="table-dark">
                            <tr>
                                <th scope="col">Specification</th>
                                <th scope="col">Details</th>
                            </tr>
                            </thead>
                            <tbody>
                            {typeData.specifications.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.spec}</td>
                                    <td>{item.details}</td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>
                )}

                <div className="text-justify">
                    <h5 data-aos="zoom-in">Features:</h5>
                    <ul className="text-muted">
                        {typeData.features.map((feature, index) => (
                            <li key={index} data-aos="zoom-in">{feature}</li>
                        ))}
                    </ul>
                </div>

                <div className="text-justify">
                    <h5 data-aos="zoom-in">Applications:</h5>
                    <ul className="text-muted">
                        {typeData.applications.map((application, index) => (
                            <li key={index} data-aos="zoom-in">{application}</li>
                        ))}
                    </ul>
                </div>

                <button
                    type="button"
                    className="btn btn-brand"
                    onClick={() => {
                        openModal("Request a Callback", "form-callback");
                    }}
                    data-aos="zoom-in"
                    data-aos-delay="300"
                >
                    Request a Callback
                </button>

                {/* Professional note */}
                {typeData.note && typeData.note.length > 0 && (
                    <p className="mt-3 text-justify text-muted" data-aos="zoom-in">
                        <strong>Note:</strong>{typeData.note}
                    </p>
                )}
            </div>
        )
    }

    return (
        <div>{renderProducts({openModal})}</div>
    );
};

export default Product;
